<template>
  <div class="box-big">
    <com-header></com-header>
    <div class="box box-column box-center router-view">
      <img src="@/assets/image/img/toHaiDian.png" style="width: 300px;height: 205px;">
      <div class="login-status">登录失败</div>
      <div class="login-desc">未查询到您在关芯的身份权限信息</div>
      <div class="login-time"><span class="login-num">{{num}}s</span>后返回</div>
      <div class="login-btn" @click="backHaiDian">立即返回</div>
    </div>
  </div>
</template>

<script>
import comHeader from "./header.vue";
export default {
  data () {
    return {
      num: 5,
      timer: null,
    }
  },
  components: {
    comHeader
  },
  mounted () {
    this.timer = setInterval(() => {
      this.num -=1;
      if (this.num <= 0) {
        this.timer = null;
        return window.location.href = 'https://zshdsq.bjhdnet.cn/management/';
      }
    }, 1000);
  },
  destroyed () {
    this.timer = null;
  },
  methods: {
    backHaiDian () {
      window.location.href = 'https://zshdsq.bjhdnet.cn/management/';
    }
  }
}
</script>

<style lang="less" scoped>
.box-big {
  background: #f1f4f6;
  height: 100vh;
  overflow: hidden;
}
.router-view {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #fff;
  border-radius: 10px;
}
.box {
  display: flex;
}
.box-column {
  flex-direction: column;
}
.box-center {
  justify-content: center;
  align-items: center;
}
.login-status {
  margin-top: 30px;
  font-family: MiSans;
    font-size: 24px;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0px;
    color: #494C4F;
}
.login-desc {
  margin-top: 12px;
  font-family: MiSans;
  font-size: 20px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0px;
  color: #92979C;
}
.login-time {
    margin-top: 12px;
    margin-bottom: 24px;
    font-family: MiSans;
    font-size: 20px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0px;
    z-index: 2;
    color: #92979C;
  .login-num {
    color: #0054FE;
  }
}
.login-btn {
  width: 158px;
  height: 40px;
  border-radius: 4px;
  opacity: 1;
  /* 自动布局 */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 16px;
  gap: 10px;
  background: #0054FE;
  font-family: MiSans;
  font-size: 16px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0px;
  color: #FFFFFF;
}
</style>


// WEBPACK FOOTER //
// src/pages/forbidden/index.vue